import * as types from "../constants/survey_constants";

const initialState = {
  surveys: [],
  currentSurvey: null,
  response: null,
  surveyError: null,
  message: null,
};

const surveyReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GET_USER_SURVEYS_SUCCESS:
      return {
        ...state,
        surveys: payload?.surveys || [],
        surveyError: null,
      };

    case types.GET_SINGLE_SURVEY_SUCCESS:
      return {
        ...state,
        currentSurvey: payload?.survey || null,
        response: payload?.response || null,
        surveyError: null,
      };

    case types.SUBMIT_SURVEY_RESPONSE_SUCCESS:
      return {
        ...state,
        response: payload?.response || null,
        message: payload?.message || null,
        surveyError: null,
      };

    case types.GET_USER_SURVEYS_FAILURE:
    case types.GET_SINGLE_SURVEY_FAILURE:
    case types.SUBMIT_SURVEY_RESPONSE_FAILURE:
      return {
        ...state,
        surveyError: payload || null,
      };

    default:
      return state;
  }
};

export default surveyReducer;
